<template>
    <div class="row-skeleton-root mb-2" :class="{ 'row-round': rounded }" />
</template>

<script>
export default {
    props: {
        rounded: Boolean,
    },
};
</script>

<style scoped>
.row-skeleton-root {
    width: 100%;
    max-width: 100%;
    height: 16px;

    background-color: rgb(230, 230, 230);
}

.row-round {
    border-radius: 4px;
}
</style>
